import React from 'react';
import { t } from 'i18next';
import { ArrowLeft, CheckCircle2 } from 'lucide-react';
import { RadixButton, RadixCard } from '@/components/radix';
import { useLoginV3Flow } from './LoginV3FlowProvider';

export default function LoginV3ResetSuccessCard() {
    const { goBackInFlow, afterResetCompleteContinue } = useLoginV3Flow();

    return (
        <RadixCard className="!p-0 border !border-[#E6E1D9] shadow-xl rounded-md bg-white/95 backdrop-blur-md overflow-hidden">
            <div className="relative bg-white p-6 sm:p-8 pb-4 text-center border-b border-[#F0EDE8]">
                <button
                    type="button"
                    onClick={goBackInFlow}
                    aria-label={t('Common.Back')}
                    className="absolute left-4 top-1/2 -translate-y-1/2 p-2 text-gray-400 hover:text-primary-500 transition-colors bg-transparent border-none outline-none cursor-pointer"
                >
                    <ArrowLeft size={20} />
                </button>

                <h1 className="text-xl sm:text-2xl font-bold text-gray-900 tracking-tight">
                    {t('Common.SuccessResspass')}
                </h1>
            </div>

            <div className="p-8 sm:p-10 flex flex-col items-center">
                <div className="relative mb-8">
                    <div className="w-24 h-24 sm:w-32 sm:h-32 rounded-full bg-primary-50 border border-primary-100 flex items-center justify-center animate-pulse shadow-inner">
                        <CheckCircle2 size={64} className="text-primary-500" strokeWidth={1.5} />
                    </div>
                </div>

                <div className="text-center mb-10">
                    <p className="text-gray-600 text-sm sm:text-base leading-relaxed px-4">
                        {t('Common.SuccessrespassDesc')}
                    </p>
                </div>

                <RadixButton
                    type="button"
                    variant="primary"
                    onClick={() => void afterResetCompleteContinue()}
                    className="w-full !h-12 sm:!h-14 !rounded-xl !text-base font-bold shadow-lg shadow-primary-500/20 text-white transition-all active:scale-95"
                >
                    {t('Common.SuccessresPasBTn')}
                </RadixButton>
            </div>
        </RadixCard>
    );
}
